export const MILESTONE_TYPE_LABELS = {
  SELF: "Self Rated"
} as const;
